<template>
   <div class="loader-wrap">
       <div class="loader" id="loader-7"></div>
   </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style>
    .loader-wrap {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loader {
        width: 100px;
        height: 100px;
        border-radius: 100%;
        position: relative;
        margin: 0 auto;
    }

    #loader-7{
        -webkit-perspective: 120px;
        -moz-perspective: 120px;
        -ms-perspective: 120px;
        perspective: 120px;
    }

    #loader-7:before{
        content: "";
        position: absolute;
        left: 25px;
        top: 25px;
        width: 50px;
        height: 50px;
        background-color: #3498db;
        animation: flip 1s infinite;
    }

    @keyframes flip {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotateY(180deg);
        }

        100% {
            transform: rotateY(180deg)  rotateX(180deg);
        }
    }
</style>